import { DropdownMenu } from "@kobalte/core/dropdown-menu";
import { A } from "@solidjs/router";
import { For } from "solid-js";

export const Menu = (props) => {
	return (
		<DropdownMenu>
			<DropdownMenu.Trigger class="bg-transparent outline-none border-none inline-flex py-2 md:px-3 text-base font-semibold text-gray-900 hover:bg-slate-50">
				{props.caption}
				<svg
					viewBox="0 0 20 20"
					fill="currentColor"
					aria-hidden="true"
					class="-mr-1 size-5 text-gray-400">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
					/>
				</svg>
			</DropdownMenu.Trigger>
			<DropdownMenu.Portal>
				<DropdownMenu.Content class="w-56 origin-top-right rounded-md bg-white shadow-lg outline-1 outline-black/5 transition">
					<div class="py-1">
						<For each={props.items}>
							{(item) => (
								<DropdownMenu.Item class="block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900">
									<A href={item.href}>{item.caption}</A>
								</DropdownMenu.Item>
							)}
						</For>
					</div>
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu>
	);
};
